import acl from '@/services/acl';

// The block children render the same orchestrator (MonitoringDashboardIndex);
// `monitoringBlocks` meta drives which blocks each page shows and fetches.
// `to-complete` has its own view and its own filter key, passed via overrides.
const childMeta = (routePermissions, monitoringBlocks, overrides = {}) => ({
  tabbable: true,
  tableKeys: ['monitoringDashboard'],
  filterKeys: ['monitoringDashboard'],
  formKeys: [],
  routePermissions,
  monitoringBlocks,
  ...overrides,
});

const indexComponent = () =>
  import(
    /* webpackChunkName: "monitoringDashboardIndex" */ '../views/monitoringDashboard/MonitoringDashboardIndex.vue'
  );

export default [
  {
    path: 'monitoring-dashboard',
    name: 'monitoringDashboard',
    redirect: () =>
      acl.userCanUse(['dashboardMonitoringView'])
        ? { name: 'monitoringDashboardExpiring' }
        : { name: 'monitoringDashboardAcceptance' },
    component: () =>
      import(
        /* webpackChunkName: "monitoringDashboard" */ '../views/monitoringDashboard/MonitoringDashboard.vue'
      ),
    children: [
      {
        path: 'acceptance',
        name: 'monitoringDashboardAcceptance',
        meta: childMeta(['dashboardMonitoringAcceptanceView'], ['acceptance']),
        component: indexComponent,
      },
      {
        path: 'expiring',
        name: 'monitoringDashboardExpiring',
        meta: childMeta(['dashboardMonitoringView'], ['expired', 'closing']),
        component: indexComponent,
      },
      {
        path: 'processing',
        name: 'monitoringDashboardProcessing',
        meta: childMeta(['dashboardMonitoringView'], ['awaitingProcessing']),
        component: indexComponent,
      },
      {
        path: 'to-complete',
        name: 'monitoringDashboardToComplete',
        meta: childMeta(['dashboardMonitoringView'], ['toComplete'], {
          // own filter key, and no shared table state: the page paginates itself
          tableKeys: [],
          filterKeys: ['monitoringToComplete'],
        }),
        component: () =>
          import(
            /* webpackChunkName: "monitoringDashboardToComplete" */ '../views/monitoringDashboard/MonitoringDashboardToComplete.vue'
          ),
      },
    ],
  },
];
